/**
 * Gates Page - Coming Soon
 * Gestion Portails: Principal + Parking
 */
import Layout from '@/components/Layout';
import { DoorOpen, Lock, Clock, AlertTriangle, Settings, Calendar } from 'lucide-react';

const Gates = () => {
  const gates = [
    {
      id: "main",
      name: "Portail Principal",
      description: "Entrée propriété",
      status: "motorized",
      statusText: "Motorisé - À connecter",
      icon: <DoorOpen className="w-6 h-6" />
    },
    {
      id: "parking",
      name: "Portail Parking",
      description: "Accès véhicules",
      status: "pending",
      statusText: "À motoriser",
      icon: <DoorOpen className="w-6 h-6" />
    }
  ];

  const scenarios = [
    {
      icon: <Clock className="w-4 h-4" />,
      title: "Fermeture automatique",
      description: "Fermer tous les portails à 22h00"
    },
    {
      icon: <Calendar className="w-4 h-4" />,
      title: "Mode vacances",
      description: "Portails verrouillés en permanence"
    },
    {
      icon: <Lock className="w-4 h-4" />,
      title: "Ouverture sur appel",
      description: "Ouvrir le portail sur détection interphone"
    }
  ];

  return (
    <Layout title="Portails">
      <div className="h-full flex flex-col">
        {/* Header */}
        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-orange-900/50 border-2 border-orange-500 mb-3">
            <DoorOpen className="w-8 h-8 text-orange-400" />
          </div>
          <h2 className="text-2xl font-bold text-orange-400 font-mono">GESTION PORTAILS</h2>
          <p className="text-gray-400 text-sm mt-1">Module en préparation</p>
        </div>

        {/* Coming Soon Banner */}
        <div className="bg-yellow-900/30 border border-yellow-500/50 rounded-lg p-4 mb-6 flex items-center gap-3">
          <AlertTriangle className="w-5 h-5 text-yellow-400 flex-shrink-0" />
          <div>
            <div className="text-yellow-400 font-bold text-sm">CONNEXION EN ATTENTE</div>
            <div className="text-yellow-300/70 text-xs">
              Module WiFi requis pour intégration avec HAL 3000
            </div>
          </div>
        </div>

        {/* Gates Grid */}
        <div className="grid grid-cols-2 gap-4 mb-6">
          {gates.map((gate) => (
            <div 
              key={gate.id}
              className="bg-black/40 border border-gray-700 rounded-lg p-4"
              data-testid={`gate-${gate.id}`}
            >
              <div className="flex items-center gap-2 mb-2">
                <div className={gate.status === 'motorized' ? 'text-orange-400' : 'text-gray-500'}>
                  {gate.icon}
                </div>
                <span className="text-white font-bold">{gate.name}</span>
              </div>
              <p className="text-gray-500 text-xs mb-2">{gate.description}</p>
              
              <div className="flex items-center gap-1 mb-3">
                <div className={`w-2 h-2 rounded-full ${
                  gate.status === 'motorized' ? 'bg-orange-500' : 'bg-gray-600'
                }`}></div>
                <span className={`text-[10px] ${
                  gate.status === 'motorized' ? 'text-orange-400' : 'text-gray-500'
                }`}>
                  {gate.statusText}
                </span>
              </div>
              
              {/* Control buttons */}
              <div className="flex gap-2">
                <button 
                  disabled
                  className="flex-1 py-2 bg-gray-800 text-gray-500 rounded text-xs cursor-not-allowed flex items-center justify-center gap-1"
                >
                  <DoorOpen className="w-3 h-3" />
                  OUVRIR
                </button>
                <button 
                  disabled
                  className="flex-1 py-2 bg-gray-800 text-gray-500 rounded text-xs cursor-not-allowed flex items-center justify-center gap-1"
                >
                  <Lock className="w-3 h-3" />
                  FERMER
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Scenarios Section */}
        <div className="bg-orange-900/20 border border-orange-500/30 rounded-lg p-4 mb-4">
          <h4 className="text-orange-400 font-bold text-sm mb-3 flex items-center gap-2">
            <Settings className="w-4 h-4" />
            SCÉNARIOS PRÉVUS
          </h4>
          <div className="space-y-2">
            {scenarios.map((scenario, index) => (
              <div key={index} className="flex items-center gap-2 text-gray-400 opacity-60">
                <div className="text-orange-400/50">{scenario.icon}</div>
                <div>
                  <div className="text-xs font-medium">{scenario.title}</div>
                  <div className="text-[10px] text-gray-500">{scenario.description}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Info */}
        <div className="bg-gray-900/50 border border-gray-700 rounded-lg p-3 text-xs text-gray-400">
          <strong className="text-white">Note :</strong> Pour intégrer les portails, vérifiez si votre motorisation 
          dispose d'un module WiFi optionnel (Somfy, Nice, FAAC, etc.) ou utilisez un relais WiFi Tuya.
        </div>
      </div>
    </Layout>
  );
};

export default Gates;
